import { useState } from "react";
import "./editorialForms.css";

const categories = [
  { id: "pizza", name: "Pizza" },
  { id: "burger", name: "Hambúrguer" },
  { id: "japanese", name: "Japonesa" },
  { id: "chinese", name: "Chinesa" },
  { id: "brazilian", name: "Brasileira" },
  { id: "healthy", name: "Saudável" },
  { id: "dessert", name: "Sobremesas" },
  { id: "drinks", name: "Bebidas" },
  { id: "vegan", name: "Vegano" },
  { id: "other", name: "Outros" },
];

export default function FoodDeliveryForm({ data, onChange }) {
  const [customizationInput, setCustomizationInput] = useState("");

  const handleAddCustomization = () => {
    if (customizationInput.trim()) {
      onChange({
        ...data,
        customizations: [
          ...(data?.customizations || []),
          { name: customizationInput.trim(), options: [], required: false },
        ],
      });
      setCustomizationInput("");
    }
  };

  const handleRemoveCustomization = (index) => {
    onChange({
      ...data,
      customizations: (data?.customizations || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form food_delivery_form">
      <div className="editorial_form_section">
        <label>
          Nome do Restaurante <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Pizzaria do João"
          value={data?.restaurantName || ""}
          onChange={(e) => onChange({ ...data, restaurantName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Nome do Item <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Pizza Margherita Grande"
          value={data?.itemName || ""}
          onChange={(e) => onChange({ ...data, itemName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Ingredientes, tamanho, porção..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={500}
          rows={2}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Preço (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.price || ""}
            onChange={(e) =>
              onChange({ ...data, price: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tempo de Preparo (min)</label>
          <input
            type="number"
            placeholder="30"
            value={data?.preparationTime || ""}
            onChange={(e) =>
              onChange({ ...data, preparationTime: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Taxa de Entrega (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.deliveryFee || ""}
            onChange={(e) =>
              onChange({ ...data, deliveryFee: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Pedido Mínimo (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.minimumOrder || ""}
            onChange={(e) =>
              onChange({ ...data, minimumOrder: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Frete Grátis a partir de (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.freeDeliveryMinimum || ""}
            onChange={(e) =>
              onChange({
                ...data,
                freeDeliveryMinimum: parseFloat(e.target.value) || 0,
              })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Personalizações
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddCustomization}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Tamanho, Borda, Adicionais..."
          value={customizationInput}
          onChange={(e) => setCustomizationInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddCustomization()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.customizations || []).map((item, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveCustomization(i)}
              style={{ cursor: "pointer" }}
            >
              {item.name} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isAvailable"
            checked={data?.isAvailable !== false}
            onChange={(e) => onChange({ ...data, isAvailable: e.target.checked })}
          />
          <label htmlFor="isAvailable">Disponível para pedidos</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z" />
        </svg>
        <span>
          Adicione fotos apetitosas do prato para atrair mais clientes!
        </span>
      </div>
    </div>
  );
}
